// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Outfit-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/SF-Pro-Display-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/SF-Pro-Display-Semibold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Outfit';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'SF Pro Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'SF Pro Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'SF Pro Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'SF Pro Display';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
  font-weight: 700;
  font-style: normal;
}

body {
  font-family: 'SF Pro Display', sans-serif;

  .p-dropdown-item-empty {
    display: none !important;
  }

  .p-checkbox.p-highlight .p-checkbox-box {
    background-color: #6777FF !important;
    border-color: #6777FF !important;
  }

  .p-checkbox-icon {
    color: white;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,+DAAgE;EAChE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAAwE;EACxE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAAwE;EACxE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAAyE;EACzE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAAyE;EACzE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;;EAEzC;IACE,wBAAwB;EAC1B;;EAEA;IACE,oCAAoC;IACpC,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["@font-face {\r\n  font-family: 'Outfit';\r\n  src: url('./assets/fonts/Outfit-Regular.ttf') format('truetype');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'SF Pro Display';\r\n  src: url('./assets/fonts/SF-Pro-Display-Regular.otf') format('opentype');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'SF Pro Display';\r\n  src: url('./assets/fonts/SF-Pro-Display-Regular.otf') format('opentype');\r\n  font-weight: 500;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'SF Pro Display';\r\n  src: url('./assets/fonts/SF-Pro-Display-Semibold.otf') format('opentype');\r\n  font-weight: 600;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'SF Pro Display';\r\n  src: url('./assets/fonts/SF-Pro-Display-Semibold.otf') format('opentype');\r\n  font-weight: 700;\r\n  font-style: normal;\r\n}\r\n\r\nbody {\r\n  font-family: 'SF Pro Display', sans-serif;\r\n\r\n  .p-dropdown-item-empty {\r\n    display: none !important;\r\n  }\r\n\r\n  .p-checkbox.p-highlight .p-checkbox-box {\r\n    background-color: #6777FF !important;\r\n    border-color: #6777FF !important;\r\n  }\r\n\r\n  .p-checkbox-icon {\r\n    color: white;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
